import merge from 'deepmerge';

import { type TrackingObject } from './types.ts';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isEmpty(value: any): boolean {
    return value ? !Object.keys(value).length : true;
}

export function pick<T extends ObjectType>(data: T, dataKeys: string[]): T {
    return Object.keys(data).reduce((acc, key: keyof T) => {
        if (typeof key !== 'number' && dataKeys.indexOf(key as string) !== -1) {
            acc[key] = data[key];
        }
        return acc;
    }, {} as T);
}

export function omit<T extends ObjectType>(data: T, dataKeys: string[]): T {
    return Object.keys(data).reduce((acc, key: keyof T) => {
        if (typeof key !== 'number' && dataKeys.indexOf(key as string) === -1) {
            acc[key] = data[key];
        }
        return acc;
    }, {} as T);
}

/**
 * this helper function is used in tracking.trackPageView, tracking.trackSocial, and tracking.trackEvent
 * to merge additional data into the trackObject that is pushed to the dataLayer
 * @param gtmData
 * @param trackObj
 */
export function mergeAdditionalData(
    gtmData: TrackingObject,
    trackObj: TrackingObject
): TrackingObject {
    const additionalData: TrackingObject['additional'] =
        trackObj && trackObj.additional ? trackObj.additional : {};
    return merge(gtmData, additionalData);
}

/**
 * helper method used to parse a pdp url for an item's category level (L1/L2/L3), name and id
 * @param url
 * @returns {*}
 */
export const ecomParseUrl = (
    url?: string | number | boolean | null // only added `number` to accommodate EcomProduct type
): { category?: string; name?: string; id?: string } => {
    if (typeof url !== 'string') {
        return {};
    }

    if (url.startsWith('https://')) {
        const noProto = url.split('https://')[1];
        url = noProto.slice(noProto.indexOf('/'));
    }

    // given a pdp url of the form -->
    //      /{L1}/{l2}/{L3}/{product name}/id-{item pk}/?{random params}
    // set pathArr to
    //      [path, {L1/L2/L3}, {L1}, {L2}, {L3}, {product name}, {item pk}]
    const pathArr =
        /^\/(?:([^\/]*)\/([^\/]*)(?:(?:\/([^\/]*)(?:\/([^\/]*)))|(?:\/([^\/]*))?))\/id-([^/]+)\/?$/i.exec(
            url
        );
    if (pathArr === null) {
        return {};
    }
    // grab the item id, the product name and the uri substring for the categories
    return {
        category: [pathArr[1], pathArr[2], pathArr[3]]
            .filter(function (elem) {
                return !!elem;
            })
            .join('/'), // {L1/L2/L3}
        name: (pathArr[4] || pathArr[5] || '').split('-').join(' '),
        id: pathArr[6],
    };
};
